export default __webpack_public_path__ + "static/media/verlinde-appstore-qr.2245b55a.jpg";